/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DepartementProjection
 */
export interface DepartementProjection {
    /**
     * 
     * @type {number}
     * @memberof DepartementProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DepartementProjection
     */
    name: string;
}

/**
 * Check if a given object implements the DepartementProjection interface.
 */
export function instanceOfDepartementProjection(value: object): value is DepartementProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DepartementProjectionFromJSON(json: any): DepartementProjection {
    return DepartementProjectionFromJSONTyped(json, false);
}

export function DepartementProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DepartementProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DepartementProjectionToJSON(json: any): DepartementProjection {
    return DepartementProjectionToJSONTyped(json, false);
}

export function DepartementProjectionToJSONTyped(value?: DepartementProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

